// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const Camera = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M6.706 2A4.696 4.696 0 002 6.706v10.588A4.696 4.696 0 006.706 22h10.588A4.696 4.696 0 0022 17.294V6.706A4.696 4.696 0 0017.294 2H6.706zm11.176 2.941a1.176 1.176 0 110 2.353 1.176 1.176 0 010-2.353zM12 7c2.754 0 5 2.246 5 5s-2.246 5-5 5-5-2.246-5-5 2.246-5 5-5zm0 1.176A3.815 3.815 0 008.176 12 3.815 3.815 0 0012 15.824 3.815 3.815 0 0015.824 12 3.815 3.815 0 0012 8.176z" />
  </svg>
);

export default Camera;
